var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFirefox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M146.198 37.4041C142.432 41.7885 140.672 51.6699 144.497 61.675C148.314 71.6873 154.174 69.5132 157.823 79.7218C162.644 93.1879 160.397 111.286 160.397 111.286C160.397 111.286 166.192 128.06 170.227 110.239C179.155 76.777 146.198 45.6495 146.198 37.4041Z",
    fill: "url(#paint0_radial_604_1176)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M100.22 176.362C138.804 176.362 170.06 144.929 170.06 106.182C170.06 67.4339 138.804 36.001 100.256 36.001C61.7083 36.001 30.4528 67.4267 30.4528 106.182C30.3801 144.973 61.672 176.362 100.22 176.362Z",
    fill: "url(#paint1_radial_604_1176)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M152.553 149.452C151.04 150.521 149.455 151.473 147.812 152.309C149.993 149.117 152.007 145.809 153.839 142.399C155.33 140.748 156.689 139.149 157.802 137.418C158.34 136.567 158.951 135.52 159.598 134.299C163.516 127.231 167.842 115.801 167.966 104.058V104.029C167.966 103.738 167.973 103.448 167.966 103.164C167.988 100.219 167.682 97.2745 167.064 94.3951C167.093 94.6205 167.123 94.8459 167.152 95.0713C167.115 94.8968 167.086 94.7223 167.05 94.5478C167.108 94.8677 167.152 95.1804 167.203 95.4858C168.002 102.284 167.435 108.923 164.578 113.809C164.534 113.882 164.483 113.947 164.44 114.02C165.923 106.589 166.417 98.3797 164.767 90.1633C164.767 90.1633 164.105 86.1715 159.198 74.0433C156.377 67.063 151.36 61.3406 146.925 57.1743C143.043 52.3681 139.509 49.1397 137.568 47.0965C133.504 42.8211 131.803 39.6146 131.105 37.5205C130.501 37.2151 122.744 29.6823 122.126 29.3987C118.738 34.6484 108.094 51.0593 113.161 66.4013C115.459 73.3525 121.261 80.5654 127.331 84.6155C127.6 84.9208 130.945 88.5564 132.537 96.7582C134.18 105.229 133.315 111.838 129.934 121.618C125.957 130.198 115.764 138.676 106.218 139.541C85.8173 141.396 78.3433 129.296 78.3433 129.296C85.6356 132.212 93.6912 131.601 98.5987 128.577C103.543 125.523 106.531 123.254 108.952 124.148C111.344 125.036 113.249 122.454 111.54 119.779C108.843 115.627 103.928 113.482 99.0495 114.34C94.1056 115.147 89.5761 119.059 83.0909 115.27C82.6692 115.03 82.2621 114.761 81.8768 114.471C81.4478 114.187 83.2654 114.9 82.8437 114.58C81.5859 113.896 79.3539 112.398 78.7723 111.868C78.6778 111.78 79.7538 112.209 79.652 112.122C73.5957 107.134 74.3519 103.76 74.5409 101.644C74.6936 99.9502 75.7914 97.7834 77.6454 96.9036C78.5396 97.3908 79.0995 97.7689 79.0995 97.7689C79.0995 97.7689 78.7141 96.9909 78.5106 96.5764C78.5833 96.5473 78.6487 96.5546 78.7214 96.5255C79.4557 96.8818 81.077 97.798 81.9349 98.3578C83.0473 99.1431 83.4035 99.8411 83.4035 99.8411C83.4035 99.8411 83.6944 99.6812 83.4763 98.9977C83.3963 98.7141 83.0618 97.827 81.9567 96.9254L82.0222 96.9327C82.6838 97.3108 83.309 97.7398 83.8907 98.227C84.2033 97.0999 84.7631 95.9147 84.6395 93.8061C84.5668 92.3228 84.5959 91.9375 84.3342 91.363C84.1015 90.8686 84.465 90.6796 84.8722 91.1885C84.7995 90.7886 84.6831 90.396 84.5232 90.0252V89.9888C85.0321 88.2219 95.2616 83.6193 96.0032 83.0812C97.2246 82.216 98.2498 81.1035 99.0132 79.8093C99.5803 78.9004 100.009 77.6279 100.111 75.7011C100.169 74.3123 99.5221 73.3816 89.1763 72.2982C86.3481 72.0219 84.6904 69.9714 83.7453 68.081C83.5708 67.6738 83.3963 67.303 83.2218 66.9321C83.0546 66.5031 82.9164 66.0596 82.8219 65.6088C84.5159 60.7517 87.3514 56.6435 91.5319 53.5387C91.7573 53.3279 90.6231 53.5896 90.8485 53.3861C91.1175 53.1461 92.8478 52.4481 93.175 52.2881C93.5749 52.0991 91.4665 51.2047 89.598 51.4229C87.7004 51.6337 87.2932 51.8664 86.2826 52.2954C86.7043 51.8737 88.0421 51.3283 87.7295 51.3283C85.6792 51.641 83.1418 52.8335 80.9607 54.1786C80.9534 53.9459 81.0043 53.7133 81.0916 53.4951C80.081 53.9241 77.5872 55.6619 76.8674 57.1379C76.8965 56.8544 76.9111 56.5708 76.9111 56.2872C76.1404 56.9344 75.4424 57.6615 74.8317 58.4613L74.7954 58.4976C68.9209 56.1273 63.7443 55.9746 59.3675 57.0362C58.4078 56.0764 57.9425 56.7744 55.7614 51.99C55.616 51.6992 55.8777 52.2736 55.7614 51.99C55.4051 51.0593 55.9795 53.2261 55.7614 51.99C52.0971 54.8839 47.2768 58.1559 44.9648 60.4681C44.9357 60.5626 47.6621 59.6974 44.9648 60.4681C44.0196 60.7371 44.0851 61.297 43.9397 66.3722C43.9033 66.7576 43.9324 67.1866 43.9033 67.5356C42.0566 69.8915 40.7988 71.8837 40.319 72.9162C37.927 77.039 35.2951 83.4594 32.7432 93.6171C33.8701 90.8613 35.2224 88.2074 36.8001 85.6843C34.6771 91.0795 32.6269 99.543 32.2197 112.58C32.7359 109.89 33.3903 107.229 34.19 104.611C33.6884 115.43 35.5569 126.228 39.6574 136.248C41.126 139.839 43.5543 145.286 47.6839 151.262C60.6689 164.925 78.9831 173.432 99.2676 173.432C120.468 173.432 139.488 164.169 152.553 149.452Z",
    fill: "url(#paint2_linear_604_1176)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M136.885 159.377C162.513 156.41 173.855 130.001 159.285 129.478C146.125 129.063 124.743 160.78 136.885 159.377Z",
    fill: "url(#paint3_radial_604_1176)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M161.132 124.09C178.763 113.831 174.168 91.6611 174.168 91.6611C174.168 91.6611 167.363 99.5648 162.739 112.166C158.173 124.643 150.531 130.285 161.132 124.09Z",
    fill: "url(#paint4_radial_604_1176)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M105.157 172.494C129.738 180.339 150.866 160.969 137.844 154.505C126.001 148.674 93.4947 168.785 105.157 172.494Z",
    fill: "url(#paint5_radial_604_1176)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M162.964 133.499C163.56 132.656 164.367 129.951 165.087 128.744C169.427 121.734 169.456 116.15 169.456 116.027C172.081 102.931 171.841 97.5871 170.227 87.6984C168.926 79.7365 163.255 68.3281 158.34 62.8385C153.272 57.1815 156.842 59.0211 151.935 54.8911C147.638 50.1213 143.464 45.4023 141.196 43.5046C124.787 29.784 125.157 26.8683 125.47 26.3738C125.419 26.432 125.339 26.5192 125.237 26.6356C125.041 25.8576 124.903 25.2104 124.903 25.2104C124.903 25.2104 115.931 34.183 114.048 49.1251C112.812 58.883 116.469 69.0553 121.755 75.5629C124.51 78.9294 127.622 81.9906 131.039 84.6881V84.6809C135.038 90.4178 137.234 97.4998 137.234 105.12C137.234 124.199 121.762 139.665 102.677 139.665C100.075 139.665 97.4862 139.374 94.9488 138.8C85.9408 137.084 80.7424 132.539 78.1469 129.456C76.6637 127.689 76.0312 126.403 76.0312 126.403C84.1014 129.296 93.0222 128.686 98.4459 125.69C103.913 122.658 107.221 120.411 109.904 121.298C112.551 122.178 114.659 119.619 112.769 116.965C110.915 114.311 106.094 110.515 98.9403 111.569C93.4657 112.369 88.4491 116.252 81.2804 112.486C80.8151 112.246 80.3716 111.984 79.9354 111.693C79.4628 111.417 81.4695 112.115 81.0042 111.802C79.6082 111.126 77.1363 109.643 76.4965 109.119C76.3874 109.032 77.5798 109.461 77.4707 109.374C70.7674 104.422 71.6035 101.084 71.8143 98.9831C71.9815 97.3035 73.203 95.1585 75.2532 94.286C76.242 94.7732 76.86 95.144 76.86 95.144C76.86 95.144 76.4383 94.3733 76.2057 93.9588C76.2856 93.9297 76.3656 93.937 76.4383 93.9079C77.2526 94.2569 79.0484 95.1731 79.9936 95.7257C81.2223 96.5037 81.6149 97.2017 81.6149 97.2017C81.6149 97.2017 81.942 97.0418 81.7021 96.3655C81.6149 96.0892 81.2441 95.2022 80.0226 94.3078L80.0953 94.3151C80.8224 94.6859 81.5131 95.1149 82.1602 95.6021C82.5019 94.4823 83.1198 93.3117 82.989 91.2176C82.909 89.7488 82.9454 89.3635 82.6545 88.7963C82.3928 88.3092 82.7999 88.1201 83.2507 88.6218C83.1707 88.2219 83.0471 87.8365 82.8654 87.4657L82.8727 87.4293C83.4325 85.677 94.7598 81.118 95.5814 80.58C96.9119 79.7438 98.046 78.6386 98.9112 77.337C99.5438 76.4354 100.016 75.1775 100.133 73.2652C100.169 72.4 99.9073 71.7237 96.9046 71.0693C95.1015 70.6767 92.3169 70.2986 88.0274 69.8914C84.8938 69.6151 83.0617 67.5792 82.0147 65.7033C81.8257 65.2961 81.6294 64.9325 81.4331 64.569C81.2513 64.14 81.0987 63.7037 80.9896 63.2529C82.8727 58.3376 86.2461 54.1495 90.6447 51.2774C90.8992 51.0738 89.6342 51.3283 89.8886 51.1247C90.1794 50.8847 92.0988 50.194 92.4624 50.034C92.9059 49.845 90.5648 48.9579 88.5072 49.176C86.4061 49.3869 85.9626 49.6123 84.8357 50.0413C85.301 49.6268 86.7841 49.0815 86.4352 49.0888C84.1668 49.4014 81.3531 50.5794 78.9466 51.9172C78.9393 51.6846 78.9902 51.4519 79.092 51.241C77.9724 51.67 75.2169 53.3933 74.4171 54.8548C74.4535 54.5785 74.468 54.2949 74.4608 54.0113C73.6174 54.6439 72.8467 55.3638 72.1633 56.1636L72.1197 56.1999C65.6126 53.8514 59.8908 53.6987 55.0414 54.753C53.9799 53.8005 52.2787 52.3535 49.8649 47.6127C49.6977 47.3292 49.6104 48.2017 49.4868 47.9181C48.5489 45.7441 47.9818 42.1812 48.0764 39.7309C48.0764 39.7309 46.1352 40.6107 44.5357 44.3044C44.2376 44.9661 44.0485 45.3369 43.8595 45.7004C43.7723 45.8095 44.0558 44.4862 44.0122 44.5589C43.7359 45.0315 43.0089 45.6932 42.6962 46.5439C42.4781 47.1765 42.1728 47.5328 41.9765 48.318L41.9328 48.3908C41.9183 48.1581 41.991 47.431 41.9401 47.5837C41.1913 49.1033 40.5442 50.6739 40.0062 52.2808C39.141 55.1238 38.1377 58.9848 37.9777 64.0164C37.9414 64.3945 37.9705 64.8235 37.9414 65.1652C35.8984 67.4992 34.5025 69.477 33.979 70.5022C31.3253 74.574 28.4098 80.9435 25.5816 91.014C26.8394 88.2655 28.3444 85.6261 30.0748 83.1467C27.7264 88.4909 25.458 96.8891 25 109.824C25.5671 107.149 26.3014 104.509 27.1811 101.921C26.774 110.544 27.7773 121.233 33.2301 133.296C36.4655 140.392 43.9177 154.796 62.1228 166.037C80.328 177.278 68.3172 170.647 78.9612 174.101C79.7464 174.385 80.5461 174.668 81.3604 174.937C81.1132 174.835 80.866 174.726 80.6188 174.617C87.7075 176.74 95.0579 177.824 102.459 177.824C130.021 177.846 138.15 166.779 138.15 166.779C138.15 166.779 138.121 166.801 138.07 166.837C138.455 166.474 138.833 166.088 139.197 165.696C134.849 169.804 124.925 170.073 121.21 169.782C127.535 167.921 131.701 166.35 139.8 163.245C140.745 162.896 141.72 162.496 142.708 162.046C142.817 162.002 142.926 161.944 143.028 161.9C143.225 161.806 143.421 161.726 143.617 161.624C147.565 159.762 151.273 157.443 154.675 154.702C162.811 148.201 164.578 141.868 165.508 137.695C165.378 138.094 164.978 139.025 164.694 139.636C162.6 144.115 157.954 146.871 152.909 149.227C155.308 146.078 157.533 142.799 159.576 139.403C161.219 137.775 161.735 135.215 162.964 133.499Z",
    fill: "url(#paint6_radial_604_1176)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M153.062 149.037C156.377 145.38 159.358 141.199 161.612 136.451C167.421 124.243 176.393 103.942 169.326 82.7467C163.735 65.994 156.064 56.8325 146.329 47.8817C130.509 33.3468 126.088 26.861 126.088 23C126.088 23 107.825 43.3664 115.743 64.598C123.66 85.8296 139.888 85.0589 150.619 107.221C163.248 133.303 140.397 161.762 121.501 169.731C122.657 169.476 163.502 160.228 165.654 136.866C165.61 137.295 164.687 143.751 153.062 149.037Z",
    fill: "url(#paint7_radial_604_1176)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M100.14 73.2506C100.205 71.8691 99.4855 70.9457 88.0783 69.8768C83.3816 69.4406 81.5858 65.107 81.0405 63.2747C79.3683 67.6155 78.6849 72.1599 79.0557 77.6714C79.3102 81.2779 81.7312 85.1461 82.8872 87.422C82.8872 87.422 83.1417 87.0875 83.2653 86.9639C85.4464 84.6953 94.5853 81.2343 95.4432 80.7398C96.3811 80.1436 99.9872 77.5115 100.14 73.2506Z",
    fill: "url(#paint8_linear_604_1176)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M49.9086 47.6199C49.7414 47.3364 49.6542 48.2089 49.5306 47.9253C48.5927 45.7513 48.0256 42.232 48.1565 39.738C48.1565 39.738 46.2152 40.6178 44.6158 44.3116C44.3177 44.9732 44.1286 45.3441 43.9396 45.7076C43.8524 45.8167 44.1359 44.4934 44.0923 44.5661C43.816 45.0387 43.089 45.7004 42.7763 46.5147C42.5146 47.1837 42.2529 47.54 42.0493 48.3689C41.9911 48.5943 42.1075 47.3727 42.0566 47.5254C38.3268 54.7384 37.6143 65.6378 38.0069 65.1797C45.9462 56.7016 55.0488 54.6875 55.0488 54.6875C54.0891 53.9676 51.9807 51.9099 49.9086 47.6199Z",
    fill: "url(#paint9_linear_604_1176)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M80.0443 136.313C69.0733 131.63 56.6045 125.021 57.0698 110.013C57.7096 90.2504 75.5003 94.155 75.5003 94.155C74.8314 94.315 73.0356 95.5947 72.3958 96.9617C71.727 98.6631 70.4983 102.509 74.2134 106.545C80.0516 112.871 62.2245 121.552 89.7358 137.949C90.4338 138.32 83.2942 137.716 80.0443 136.313Z",
    fill: "url(#paint10_linear_604_1176)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M76.1474 126.46C83.9268 129.164 92.9858 128.692 98.4168 125.696C102.052 123.675 106.705 120.432 109.577 121.232C107.098 120.251 105.215 119.793 102.954 119.683C102.568 119.683 102.11 119.676 101.689 119.633C100.86 119.633 100.031 119.676 99.2093 119.771C97.8061 119.902 96.2575 120.781 94.847 120.643C94.7743 120.636 96.2139 120.047 96.0976 120.076C95.3487 120.229 94.5344 120.265 93.6765 120.374C93.1312 120.432 92.6586 120.505 92.1206 120.527C75.9148 121.901 62.2245 111.744 62.2245 111.744C61.054 115.663 67.4374 123.428 76.1474 126.46Z",
    fill: "url(#paint11_linear_604_1176)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M153.033 149.139C169.42 133.048 177.716 113.489 174.204 91.5447C174.204 91.5447 175.607 102.793 170.293 114.303C172.845 103.069 173.143 89.1089 166.367 74.6539C157.322 55.3564 142.447 45.2059 136.761 40.9668C128.16 34.5464 124.591 28.017 124.525 26.6646C121.951 31.9288 114.179 49.983 123.689 65.5287C132.603 80.0927 146.642 84.419 156.464 97.776C174.575 122.396 153.033 149.139 153.033 149.139Z",
    fill: "url(#paint12_linear_604_1176)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M150.684 107.272C144.955 95.4421 137.808 90.2797 131.047 84.6809C131.832 85.7788 132.028 86.1715 132.464 86.884C138.419 93.2244 147.194 108.705 140.818 128.126C128.822 164.692 80.8515 147.474 75.8203 142.639C77.856 163.798 113.27 173.926 136.332 160.206C149.455 147.779 160.07 126.664 150.684 107.272Z",
    fill: "url(#paint13_linear_604_1176)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_604_1176",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(167.921 61.7171) rotate(2.55508) scale(54.1091 79.5399)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.045,
    stopColor: "#FFEA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#FFDE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.254,
    stopColor: "#FFBF00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.429,
    stopColor: "#FF8E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.769,
    stopColor: "#FF272D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.872,
    stopColor: "#E0255A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.953,
    stopColor: "#CC2477"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C42482"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_604_1176",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(129.335 53.3875) scale(152.502 152.516)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00CCDA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#0083FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.261,
    stopColor: "#007AF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#0060E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.333,
    stopColor: "#005FE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.438,
    stopColor: "#2639AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.522,
    stopColor: "#401E84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.566,
    stopColor: "#4A1475"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_604_1176",
    x1: 110.066,
    y1: 137.739,
    x2: 79.9397,
    y2: 39.2008,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000F43",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.485,
    stopColor: "#001962",
    stopOpacity: 0.173
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#002079",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_604_1176",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(152.163 102.598) rotate(5.67027) scale(51.4387 51.4436)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.003,
    stopColor: "#FFEA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.497,
    stopColor: "#FF272D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C42482"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_604_1176",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(152.405 53.0512) rotate(5.67019) scale(85.8997 85.9066)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.003,
    stopColor: "#FFE900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.157,
    stopColor: "#FFAF0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.316,
    stopColor: "#FF7A1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.472,
    stopColor: "#FF4E26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.621,
    stopColor: "#FF2C2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.762,
    stopColor: "#FF1434"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.892,
    stopColor: "#FF0538"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF0039"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_604_1176",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(156.628 133.496) rotate(5.67019) scale(78.8216 78.8278)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.003,
    stopColor: "#FF272D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.497,
    stopColor: "#C42482"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.986,
    stopColor: "#620700"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_604_1176",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(137.527 85.001) scale(123.068 123.079)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.156,
    stopColor: "#FFEA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.231,
    stopColor: "#FFDE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.365,
    stopColor: "#FFBF00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.541,
    stopColor: "#FF8E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.763,
    stopColor: "#FF272D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796,
    stopColor: "#F92433"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.841,
    stopColor: "#E91C45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893,
    stopColor: "#CF0E62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.935,
    stopColor: "#B5007F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_604_1176",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(128.268 23.1999) scale(145.321 145.335)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.279,
    stopColor: "#FFEA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.402,
    stopColor: "#FFDD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#FFBA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.856,
    stopColor: "#FF9100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.933,
    stopColor: "#FF6711"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994,
    stopColor: "#FF4A1D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_604_1176",
    x1: 27.8838,
    y1: 83.5872,
    x2: 83.8028,
    y2: 75.1005,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C42482",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.474,
    stopColor: "#FF272D",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.486,
    stopColor: "#FF2C2C",
    stopOpacity: 0.513
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.675,
    stopColor: "#FF7A1A",
    stopOpacity: 0.72
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.829,
    stopColor: "#FFB20D",
    stopOpacity: 0.871
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.942,
    stopColor: "#FFD605",
    stopOpacity: 0.964
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE302"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_604_1176",
    x1: 47.5341,
    y1: 63.5704,
    x2: 41.1867,
    y2: 40.8175,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#891551",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C42482",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_604_1176",
    x1: 59.6962,
    y1: 96.8115,
    x2: 72.7514,
    y2: 115.024,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.005,
    stopColor: "#891551",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484,
    stopColor: "#FF272D",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF272D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_604_1176",
    x1: 84.6295,
    y1: 128.742,
    x2: 85.8149,
    y2: 117.036,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C42482"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.083,
    stopColor: "#C42482",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.206,
    stopColor: "#C42482",
    stopOpacity: 0.565
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.328,
    stopColor: "#C42482",
    stopOpacity: 0.362
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.447,
    stopColor: "#C42482",
    stopOpacity: 0.204
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.562,
    stopColor: "#C42482",
    stopOpacity: 0.091
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.673,
    stopColor: "#C42482",
    stopOpacity: 0.023
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.773,
    stopColor: "#C42482",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_604_1176",
    x1: 122.634,
    y1: 28.6806,
    x2: 170.733,
    y2: 136.228,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF14F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.268,
    stopColor: "#FFEE4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.452,
    stopColor: "#FFE643"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.612,
    stopColor: "#FFD834"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.757,
    stopColor: "#FFC41E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.892,
    stopColor: "#FFAB02"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.902,
    stopColor: "#FFA900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.949,
    stopColor: "#FFA000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9100"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_604_1176",
    x1: 132.13,
    y1: 90.5351,
    x2: 109.346,
    y2: 151.705,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#FF8E00",
    stopOpacity: 0.858
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.084,
    stopColor: "#FF8E00",
    stopOpacity: 0.729
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#FF8E00",
    stopOpacity: 0.628
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.178,
    stopColor: "#FF8E00",
    stopOpacity: 0.557
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.227,
    stopColor: "#FF8E00",
    stopOpacity: 0.514
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.282,
    stopColor: "#FF8E00",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.389,
    stopColor: "#FF8E00",
    stopOpacity: 0.478
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.524,
    stopColor: "#FF8E00",
    stopOpacity: 0.416
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.676,
    stopColor: "#FF8E00",
    stopOpacity: 0.314
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.838,
    stopColor: "#FF8E00",
    stopOpacity: 0.172
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8E00",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirefox);
export default __webpack_public_path__ + "static/media/firefox.8e71402735dcdec9d9a696b91eb53d91.svg";
export { ForwardRef as ReactComponent };